// Shared Submissions API Service

import axios from "axios";
import { BASE_URL } from '../../../../Constants/EnvironmentVariableProvider';

const SHARED_SUBMISSIONS_API = "SharedSubmissions/";

// 1. Get All Submissions
export async function getAllSubmissions(page = 1, pageSize = 50, searchTerm = "", agencyId = null, agentId = null, fromDate = null, toDate = null, hasSharing = null) {
  const params = { page, pageSize };
  if (searchTerm) params.searchTerm = searchTerm;
  if (agencyId) params.agencyId = agencyId;
  if (agentId) params.agentId = agentId;
  if (fromDate) params.fromDate = fromDate;
  if (toDate) params.toDate = toDate;
  if (hasSharing !== null) params.hasSharing = hasSharing;
  
  const res = await axios.get(
    `${BASE_URL}${SHARED_SUBMISSIONS_API}GetAllSubmissions`,
    { params }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to fetch submissions");
  return result.data;
}

// 2. Get Submission Details
export async function getSubmissionDetails(submissionId) {
  const res = await axios.get(
    `${BASE_URL}${SHARED_SUBMISSIONS_API}GetSubmissionDetails`,
    { params: { submissionId } }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to fetch submission details");
  return result.data;
}

// 3. Create Sharing
export async function createSharing(sharingData) {
  const res = await axios.post(
    `${BASE_URL}${SHARED_SUBMISSIONS_API}CreateSharing`,
    sharingData
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to create submission sharing");
  return result;
}

// 4. Update Sharing
export async function updateSharing(sharingData) {
  const res = await axios.put(
    `${BASE_URL}${SHARED_SUBMISSIONS_API}UpdateSharing`,
    sharingData
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to update submission sharing");
  return result;
}

// 5. Remove Sharing
export async function removeSharing(submissionId) {
  const res = await axios.delete(
    `${BASE_URL}${SHARED_SUBMISSIONS_API}RemoveSharing`,
    { params: { submissionId } }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to remove submission sharing");
  return result;
}

// 6. Get Sharing History
export async function getSharingHistory(submissionId) {
  const res = await axios.get(
    `${BASE_URL}${SHARED_SUBMISSIONS_API}GetSharingHistory`,
    { params: { submissionId } }
  );
  const result = res.data;
  if (!result.success) throw new Error(result.message || "Failed to fetch sharing history");
  return result.data;
}
